/* Vellumo Home · Descripción visual de la almohada (sections/vellumo-almohada-story.liquid).
   Sin librerías: aparición al hacer scroll, vídeos diferidos, antes/después,
   "¿Cómo duermes?" y carrusel de 3 pasos. */
(function () {
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function init(root) {
    if (root.dataset.vsReady) return;
    root.dataset.vsReady = '1';

    // Aparición: cada bloque recibe .is-in al entrar en pantalla (una sola vez).
    var blocks = root.querySelectorAll('[data-vs-reveal]');
    if (!hasIO || calm) {
      blocks.forEach(function (b) { b.classList.add('is-in'); });
    } else {
      var revealIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          revealIo.unobserve(e.target);
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      blocks.forEach(function (b) { revealIo.observe(b); });
    }

    // Vídeos: el archivo solo se descarga cerca de la pantalla; se pausan al salir.
    var videos = root.querySelectorAll('video[data-vs-video]');
    if (videos.length && hasIO) {
      var videoIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (!v.dataset.loaded) {
              v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
              v.load();
              v.dataset.loaded = '1';
            }
            if (!calm) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      videos.forEach(function (v) { videoIo.observe(v); });
    }

    // Botones de oferta (recordatorio del kit y cierre): además de subir a la compra (el enlace),
    // dejan elegida la tarjeta del pack cuya variante llevan en data-vs-kit.
    root.querySelectorAll('[data-vs-kit]').forEach(function (cta) {
      cta.addEventListener('click', function () {
        var radio = document.querySelector('[data-vh-packs] input[data-variant="' + cta.dataset.vsKit + '"]');
        if (!radio || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Antes / después: el rango mueve la línea; la flecha deja de moverse al primer toque.
    // Al aparecer hace un barrido corto (derecha → izquierda → centro) para que se vean las dos líneas.
    root.querySelectorAll('[data-vs-compare]').forEach(function (cmp) {
      var range = cmp.querySelector('input[type="range"]');
      if (!range) return;
      var touched = false;
      var setPos = function (v) {
        cmp.style.setProperty('--pos', v + '%');
        range.value = v;
      };
      range.addEventListener('input', function () {
        touched = true;
        cmp.style.setProperty('--pos', range.value + '%');
        cmp.classList.add('is-touched');
      });
      if (calm || !hasIO) return;
      var sweep = function () {
        var stops = [50, 82, 18, 50];
        var leg = 0;
        var start = null;
        var step = function (now) {
          if (touched) return;
          if (start === null) start = now;
          var t = Math.min((now - start) / 520, 1);
          var e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
          setPos(Math.round(stops[leg] + (stops[leg + 1] - stops[leg]) * e));
          if (t < 1) return requestAnimationFrame(step);
          leg += 1;
          start = null;
          if (leg < stops.length - 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      var sweepIo = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        sweepIo.disconnect();
        setTimeout(sweep, 400);
      }, { threshold: 0.6 });
      sweepIo.observe(cmp);
    });

    // ¿Cómo duermes?: cambia el modo, resalta el lado y gira un poco la almohada.
    root.querySelectorAll('[data-vs-sleep]').forEach(function (box) {
      var btns = box.querySelectorAll('.vs-sleep__btn');
      var timer;
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (box.dataset.mode === btn.dataset.mode) return;
          box.dataset.mode = btn.dataset.mode;
          btns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          if (calm) return;
          box.classList.add('is-turning');
          clearTimeout(timer);
          timer = setTimeout(function () { box.classList.remove('is-turning'); }, 350);
        });
      });
    });

    // Carrusel: avanza solo cada 3,5 s mientras se ve; se puede deslizar y usar los puntos.
    root.querySelectorAll('[data-vs-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-vs-track]');
      var cards = track ? Array.prototype.slice.call(track.children) : [];
      var dots = car.querySelectorAll('[data-vs-dot]');
      if (!cards.length) return;
      var current = 0;
      var visible = false;
      var paused = false;
      var auto;
      var resume;

      var setActive = function (i) {
        current = i;
        cards.forEach(function (c, n) { c.classList.toggle('is-active', n === i); });
        dots.forEach(function (d, n) {
          if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      };
      var goTo = function (i) {
        var card = cards[i];
        track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: calm ? 'auto' : 'smooth' });
        setActive(i);
      };
      var scrolls = function () { return track.scrollWidth > track.clientWidth + 4; };
      var tick = function () {
        if (visible && !paused && scrolls()) goTo((current + 1) % cards.length);
      };

      setActive(0);
      dots.forEach(function (d, n) {
        d.addEventListener('click', function () {
          paused = true;
          clearTimeout(resume);
          resume = setTimeout(function () { paused = false; }, 6000);
          goTo(n);
        });
      });

      // La tarjeta más centrada es la activa cuando se desliza con el dedo.
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0;
          var dist = Infinity;
          cards.forEach(function (c, n) {
            var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
            if (d < dist) { dist = d; best = n; }
          });
          if (best !== current) setActive(best);
          ticking = false;
        });
      }, { passive: true });

      // Al tocarlo se pausa unos segundos para no pelearse con el dedo.
      ['pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
        track.addEventListener(ev, function () {
          paused = true;
          clearTimeout(resume);
          resume = setTimeout(function () { paused = false; }, 6000);
        }, { passive: true });
      });

      if (calm || !hasIO) return;
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        clearInterval(auto);
        if (visible) auto = setInterval(tick, 3500);
      }, { threshold: 0.5 }).observe(car);
    });
  }

  function boot() { document.querySelectorAll('[data-vs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();